import { ReactNode, useEffect } from "react";

import { defineMessages, FormattedMessage } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import { Stack, Box, xcss, media } from "@atlaskit/primitives";

import { useAnalyticsClient } from "../../../../../../../../analytics/wac-analytics/analytics-client";

import HeroTabs from "./hero-tabs";

const messages = defineMessages({
    heading: {
        id: "wacJiraServiceManagementPage.hero-heading",
        defaultMessage:
            "Unlock high-velocity teams with AI-powered service management"
    },
    subheading: {
        id: "wacJiraServiceManagementPage.hero-subheading-gwp-4949",
        defaultMessage:
            "End bad service management for good. Unite Dev, IT, and business teams on a single AI-powered platform to deliver great service experiences."
    }
});

const JsmUseCaseProductTourOnWac = () => {
    const analyticsClient = useAnalyticsClient();
    const { createAnalyticsEvent } = useAnalyticsEvents();
    // * Keep the original experiment event for attribution
    useEffect(() => {
        analyticsClient &&
            createAnalyticsEvent({
                action: "exposed",
                actionSubject: "experiment",
                attributes: {
                    cohort: "variation-one",
                    experiment: "use-case-led-jsm-product-tour-on-wac"
                }
            }).fire();
    }, [createAnalyticsEvent, analyticsClient]);

    return (
        <Box xcss={HeroContainerStyle}>
            <Stack alignInline="center">
                <Box xcss={HeroHeadingWrapperStyles}>
                    <Box as="h1" xcss={HeroHeadingStyles}>
                        <FormattedMessage
                            {...messages.heading}
                            values={{
                                span: (text: ReactNode) => (
                                    <Box as="span" xcss={HeroHeadingSpanStyles}>
                                        {text}
                                    </Box>
                                )
                            }}
                        />
                    </Box>
                </Box>
                <Box as="p" xcss={HeroSubheadingStyles}>
                    <FormattedMessage {...messages.subheading} />
                </Box>
            </Stack>

            <HeroTabs />
        </Box>
    );
};

const HeroContainerStyle = xcss({
    marginInline: "auto",
    width: "100%",
    overflow: "hidden",
    paddingBlockEnd: "space.400"
});

const HeroHeadingWrapperStyles = xcss({
    position: "relative"
});

const HeroHeadingStyles = xcss({
    textAlign: "center",
    fontSize: "48px",
    fontWeight: "800",
    lineHeight: "56px",
    maxWidth: "378px",
    marginBlockEnd: "space.0",
    [media.above.sm]: {
        maxWidth: "600px"
    },
    [media.above.lg]: {
        fontSize: "48px",
        maxWidth: "800px"
    }
});

const HeroHeadingSpanStyles = xcss({
    fontWeight: "400"
});

const HeroSubheadingStyles = xcss({
    textAlign: "center",
    marginBlockEnd: "space.400",
    maxWidth: "328px",
    fontSize: "20px",
    lineHeight: "28px",
    [media.above.xs]: {
        maxWidth: "420px"
    },
    [media.above.sm]: {
        maxWidth: "600px"
    },
    [media.above.lg]: {
        marginBlockEnd: "space.600",
        maxWidth: "800px",
        fontSize: "20px",
        lineHeight: "28px"
    }
});

export default JsmUseCaseProductTourOnWac;
